import Api from '../../../api';
import store from '../../../store';


const fetchProductionRecipeInfo = async data => {
    return fetchInfo('/Recipe/GetProductionRecipeInfo', data);
};

// int recipeID
const fetchProductionRecipe = async data => {
    return fetchInfo('/Recipe/GetProductionRecipe', data);
};
const storeProductionRecipe = async (data) => {
    return await Api(store).put('/Recipe/StoreProductionRecipe', data);
};
const storeIngredientProduction = async (data) => {
    return await Api(store).put('/IngredientProduction/StoreIngredientProduction', data);
};
//  DeleteObjectModel dom {id, LastUpdated}
const deleteIngredientProduction = async (data) => {
    //return await Api(store).delete('/IngredientProduction/DeleteIngredientProduction', data);
    return await Api(store).delete(
        '/IngredientProduction/DeleteIngredientProduction?' +
            Object.keys(data)
                .map(
                    (k) =>
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k] ?? '')
                )
                .join('&'),
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    );
};

const fetchIngredientProductionInfo = async (data) => {
    return fetchInfo('/IngredientProduction/GetIngredientProductionInfo', data);
};
// int ingredientProductionID
const fetchIngredientProduction = async (data) => {
    return fetchInfo('/IngredientProduction/GetIngredientProduction', data);
};

// int recipeID
const closeProductionRecipe = async (data) => {
    return Api(store).put(
        '/Recipe/CloseProductionRecipe?' +
            Object.keys(data)
                .map(
                    (k) =>
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k] ?? '')
                )
                .join('&'),
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    );
};

const fetchInfo = async (apicall, data) => {
    if (data != undefined) {
        return await Api(store).get(
            apicall +
                '?' +
                Object.keys(data)
                    .map(
                        (k) =>
                            encodeURIComponent(k) +
                            '=' +
                            encodeURIComponent(data[k] ?? '')
                    )
                    .join('&'),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    } else {
        return await Api(store).get(apicall, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }
};
export default {
    fetchProductionRecipeInfo,
    fetchProductionRecipe,
    storeProductionRecipe,
    storeIngredientProduction,
    closeProductionRecipe,
    fetchIngredientProductionInfo,
    fetchIngredientProduction,      
    deleteIngredientProduction
};
